module.exports = __webpack_public_path__ + "img/f5e4b155465c186c1691cbfa6dde0077.a22a3254.png";